module.exports = __webpack_public_path__ + "img/banner701.fc816a05.jpeg";